import React from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import Icon from '@visa/vds/icon';
import MCSPagedTable from '../../../../components/MCSPagedTable';

const SelectedUserTable = (props) => {
    const { fetchData, tableState, allowRemoveUser, handleClickAction } = props;

    let colHeaders = [
        { displayName: "User ID", name: "volUserId", orderable: true },
        { displayName: "Name", name: "firstName", orderable: true },
        { displayName: "Organization", name: "organizationName", orderable: true },
        { displayName: "BID", name: "bid", orderable: true },
        { displayName: "Region", name: "regionName", orderable: false },
    ];

    if (allowRemoveUser) {
        colHeaders.push({ displayName: "", name: "action", orderable: false })
    }

    function fetch(filter) {
        fetchData(filter);
    }

    return (
        <>
            {tableState.tableData && (
                <MCSPagedTable
                    size={"compact"}
                    colHeaders={colHeaders}
                    usePagination={true}
                    selectedPage={tableState.filter.selectedPage}
                    setSelectedPage={(newPage) => fetch({ ...tableState.filter, selectedPage: newPage })}
                    ordered={tableState.filter.sortBy}
                    setOrdered={(sortBy) => { }}
                    sortData={(sortBy, desc) => fetch({ ...tableState.filter, sortBy: sortBy, isDesc: desc })}
                    isDsc={tableState.filter.isDesc}
                    setDsc={(desc) => { }}
                    totalPages={tableState.totalPage}
                    pageSize={tableState.pageSize}
                    totalCount={tableState.totalCount}
                    tableData={
                        tableState.tableData.map((row, key) => (
                            <Tr key={key}>
                                <Td>{row.volUserId}</Td>
                                <Td>{row.fullName}</Td>
                                <Td>{row.organizationName}</Td>
                                <Td>{row.bid}</Td>
                                <Td>{row.regionName != "" ? row.regionName : "-"}</Td>
                                {allowRemoveUser &&
                                    <Td>
                                        <Icon className="vss-clickable-icon" name="delete" resolution="low" onClick={() => handleClickAction(row)} />
                                    </Td>
                                }
                            </Tr>
                        ))
                    }
                />
            )}
        </>
    )
}

export default SelectedUserTable;